import { RotateCw } from 'lucide-react';
import { useState } from 'react';

import { LogicPreview } from './components/LogicPreview/logic-preview';
import { QueryFilterForm } from './query-filter-form';
import { hasSavedQueryChanged } from './utils/filter-comparison';
import { isFilterEmpty } from './utils/validation-logic';

import { LogicalOperator, type SavedQueryBody } from '@/entities/query/query-types';
import { Button } from '@/shared/components/shadcn/button';
import { cn } from '@/shared/utils/cn';

interface Props {
  filterForm: SavedQueryBody;
  onChange: (filter: SavedQueryBody) => void;
}

export function EditFilterForm({ filterForm, onChange }: Props) {
  const [innerFilterForm, setInnerFilterForm] = useState<SavedQueryBody>(filterForm);
  return (
    <div className="flex w-140 flex-col gap-6 overflow-hidden p-6">
      <UpdatePreviewButton
        className="w-full"
        onClick={() => {
          onChange(innerFilterForm);
        }}
        disabled={
          !hasSavedQueryChanged(innerFilterForm, filterForm) ||
          isFilterEmpty(innerFilterForm.filter)
        }
      />
      <LogicPreview
        includeGroups={innerFilterForm.filter.include.map((include, index) => ({
          id: index.toString(),
          op: include.op,
          values: include.values,
          currentInput: '',
          nextOp: LogicalOperator.And,
        }))}
        excludeGroup={{
          values: innerFilterForm.filter.exclude.values,
          currentInput: '',
        }}
      />
      <div className="overflow-y-auto">
        <QueryFilterForm filterForm={innerFilterForm} onChange={setInnerFilterForm} />
      </div>
    </div>
  );
}

function UpdatePreviewButton({
  className,
  onClick,
  disabled = false,
}: {
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={cn('h-10', disabled && 'opacity-50', className)}
    >
      <RotateCw className="size-4" />
      Update preview
    </Button>
  );
}
